import { jsx as _jsx } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
// SPDX-License-Identifier: AGPL-3.0-only
import React, { Suspense } from "react";
import { Loader } from "@sequentech/ui-essentials";
import PublishedBallot from "./PublishedBallot";
import StartScreen from "./StartScreen";
import VotingScreen, { action as votingAction } from "./VotingScreen";
import ReviewScreen, { action as castBallotAction } from "./ReviewScreen";
import ConfirmationScreen from "./ConfirmationScreen";
import AuditScreen from "./AuditScreen";
import BallotLocator from "./BallotLocator";
/** The screens of one election, which need its published ballot. */
export var publishedBallotRoutes = [
    {
        path: "start",
        element: (_jsx(Suspense, { fallback: _jsx(Loader, {}), children: _jsx(StartScreen, {}) })),
    },
    {
        path: "vote",
        element: (_jsx(Suspense, { fallback: _jsx(Loader, {}), children: _jsx(VotingScreen, {}) })),
        action: votingAction,
    },
    {
        path: "review",
        element: (_jsx(Suspense, { fallback: _jsx(Loader, {}), children: _jsx(ReviewScreen, {}) })),
        action: castBallotAction,
    },
    {
        path: "confirmation",
        element: (_jsx(Suspense, { fallback: _jsx(Loader, {}), children: _jsx(ConfirmationScreen, {}) })),
    },
    {
        path: "audit",
        element: (_jsx(Suspense, { fallback: _jsx(Loader, {}), children: _jsx(AuditScreen, {}) })),
    },
];
export var electionRoutes = {
    path: "election/:electionId",
    children: [
        {
            element: _jsx(PublishedBallot, {}),
            children: publishedBallotRoutes,
        },
        // A stored vote remains independently readable when no active ballot
        // publication is available. This route keeps the normal authentication.
        {
            path: "ballot-locator/:ballotId?",
            element: (_jsx(Suspense, { fallback: _jsx(Loader, {}), children: _jsx(BallotLocator, {}) })),
        },
    ],
};
